import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Studio } from "@/lib/api";

const LABEL = { description: "Descrição", objective: "Objetivo", instructions: "Instruções", contraindications: "Precauções" };

// Rascunhos de conteúdo dos exercícios de casa: só preenchem campos vazios após aprovação do administrador.
export default function StudioDrafts() {
  const [rows, setRows] = useState([]);
  const load = () => Studio.drafts().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);
  const apply = async (id) => {
    if (!window.confirm("Confirma que reviu este conteúdo profissionalmente? Só os campos vazios da ficha serão preenchidos.")) return;
    try { const r = await Studio.applyDraft(id); toast.success(r.applied.length ? `Aplicado: ${r.applied.map((k) => LABEL[k]).join(", ")}` : "Nada a aplicar (campos já preenchidos)"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Falhou"); }
  };
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/40 p-5 space-y-3" data-testid="studio-drafts">
      <div className="font-display text-lg text-slate-50">Rascunhos de conteúdo · exercícios de casa</div>
      <p className="text-xs text-slate-400">Textos genéricos para revisão profissional. Não são publicados até serem aprovados aqui.</p>
      {rows.map((d) => {
        const pending = Object.keys(d.fields).filter((k) => !d.current[k] || (Array.isArray(d.current[k]) && !d.current[k].length));
        return (
          <details key={d.id} className="rounded-xl border border-slate-800 p-3" data-testid={`draft-${d.id}`}>
            <summary className="cursor-pointer text-sm text-slate-200 flex flex-wrap items-center gap-2">
              {d.name} <span className={`text-[11px] ${pending.length ? "text-amber-300" : "text-emerald-300"}`}>{pending.length ? `${pending.length} campo(s) por aprovar` : "Aplicado"}</span>
            </summary>
            <div className="mt-3 space-y-2 text-xs">
              {Object.entries(d.fields).map(([k, v]) => (
                <div key={k}><span className="text-slate-500">{LABEL[k]}{pending.includes(k) ? "" : " (já preenchido — mantém-se)"}:</span> <span className="text-slate-300">{Array.isArray(v) ? v.join(" ") : v}</span></div>
              ))}
              {pending.length > 0 && <button onClick={() => apply(d.id)} data-testid={`draft-apply-${d.id}`} className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-medium px-3 py-1.5">Aprovar e aplicar</button>}
            </div>
          </details>
        );
      })}
    </section>
  );
}
